import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from './prepareHeader';

import { getConfig } from '@/config/config';
import type { UserPreferences } from '../user/userPreferences.model';
const configuredFetchQuery = fetchBaseQuery({
  baseUrl: getConfig().apiUrl,
  prepareHeaders,
});

const prefixUrl = getConfig().prefixUrl ?? '';

export const userPreferencesApi = createApi({
  reducerPath: 'userPreferencesApi',
  baseQuery: configuredFetchQuery,
  endpoints: (builder) => ({
    getUserPreferences: builder.query<UserPreferences, void>({
      query: () => ({
        method: 'GET',
        url: `${prefixUrl}/users/preferences`,
      }),
      transformResponse: ({ data }: { data: string }) => {
        try {
          return JSON.parse(data) as UserPreferences;
        } catch (e) {
          throw Error('Invalid JSON for user preference receives from backend');
        }
      },
    }),

    saveUserPreferences: builder.mutation<void, UserPreferences>({
      query: (preferences: UserPreferences) => ({
        method: 'POST',
        url: `${prefixUrl}/users/preferences`,
        body: preferences,
      }),
    }),
  }),
});
export const {
  useGetUserPreferencesQuery,
  useLazyGetUserPreferencesQuery,
  useSaveUserPreferencesMutation,
} = userPreferencesApi;
